/* eslint-disable @typescript-eslint/no-explicit-any */
import type { modals } from "@mantine/modals";

export const isFunction = (p: unknown): p is (...args: any[]) => any => typeof p === "function";

export const isPromise = (p: unknown): p is Promise<unknown> => p instanceof Promise;

export const isArray = <T extends Array<any>>(value: unknown): value is T => Array.isArray(value);

export const isObject = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null && !isArray(value);

export const isOpenConfirmModal = (modal: unknown): modal is Parameters<typeof modals.openConfirmModal>[0] => isObject(modal) && !isFunction(modal);

export const isObjectWithMessage = (value: unknown): value is { message: string } =>
  isObject(value) && "message" in value && typeof (value as { message: unknown }).message === "string";
